import React from 'react';
import ReactDOM from 'react-dom/client';
import AppProviders from './app/providers/AppProviders';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <AppProviders>
      <App />
    </AppProviders>
  </React.StrictMode>
);
